// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import glamorous, { Div } from 'glamorous';

import FastForwardIcon from 'app/components/icons/FastForwardIcon';
import PollingCircle from './PollingCircle';

type Props = {
  pollTimestamp?: number,
  showOutline?: boolean,
  size?: number,
  isTrainingChallenge: boolean
};

const defaultProps = {
  pollTimestamp: undefined,
  showOutline: undefined,
  size: undefined
};

const Container = glamorous.div({
  alignItems: 'center',
  display: 'flex'
});

function PollingCircleFastForward({
  pollTimestamp,
  showOutline,
  size,
  isTrainingChallenge
}: Props) {
  return (
    <Container>
      {isTrainingChallenge && (
        <Div paddingRight={8}>
          <FastForwardIcon />
        </Div>
      )}
      <PollingCircle pollTimestamp={pollTimestamp} showOutline={showOutline} size={size} />
    </Container>
  );
}

PollingCircleFastForward.defaultProps = defaultProps;

function mapStateToProps(state) {
  return {
    isTrainingChallenge: state.challenge.isTrainingChallenge
  };
}

export default connect(mapStateToProps)(PollingCircleFastForward);
